var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableFilledOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 24C5.62259 24 0.25 18.6275 0.25 12C0.25 5.37259 5.62259 0 12.25 0C18.8775 0 24.25 5.37259 24.25 12C24.25 18.6275 18.8775 24 12.25 24ZM17.7812 9.08234C18.1581 8.67859 18.1363 8.0458 17.7325 7.66897C17.3288 7.29214 16.696 7.31396 16.3191 7.71771L10.3302 14.1344L8.18125 11.832C7.80442 11.4282 7.17163 11.4064 6.76788 11.7833C6.36413 12.1601 6.34231 12.7929 6.71914 13.1966L9.59914 16.2823C9.78827 16.485 10.053 16.6 10.3302 16.6C10.6074 16.6 10.8721 16.485 11.0613 16.2823L17.7812 9.08234Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableFilledOff);
export default __webpack_public_path__ + "static/media/available-filled-off.4b53b7722224535e5902711e2feb8316.svg";
export { ForwardRef as ReactComponent };